import axios from 'axios'
import config from '../../../config'

let CholesterolApi = {
  updateCholesterolTracking(model) {
    return axios.put(config.apiUrl + 'tracking/cholesterol/', model);
  },
  getCholesterolTrackingDetail(page, page_size) {
    return axios.get(config.apiUrl + 'tracking/cholesterol/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    })
  },
  deleteCholesterolTracking(progressId, trackingId) {
    return axios.delete(config.apiUrl + 'tracking/cholesterol/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    })
  },
  getCholesterolTrackingCard() {
    return axios.get(config.apiUrl + 'tracking/cholesterol/card/?requestFrom=web');
  },
  postCholesterolTracking(model) {
    return axios.post(config.apiUrl + 'tracking/cholesterol/', model);
  }
};

export default CholesterolApi



// WEBPACK FOOTER //
// ./src/api/Tracking/Cholesterol/index.js